/* VSKLO UTM attribution lazy loader — preserve immediate capture for tracked landings/cart, defer direct traffic. */
(function () {
  'use strict';

  if (window.__VSKLO_UTM_ATTRIBUTION_LOADER_V1__) return;
  window.__VSKLO_UTM_ATTRIBUTION_LOADER_V1__ = true;

  var script = document.currentScript || document.querySelector('script[src*="vsklo-utm-attribution.js"]');
  var loadPromise = null;
  var TRACKED_QUERY = /(?:^|[?&])(?:utm_(?:source|medium|campaign|content|term|id|creative|matchtype|network|placement)|gclid|gbraid|wbraid|fbclid|ttclid|msclkid|epik|sccid|ScCid|yclid|gad_source)=/i;

  function coreUrl() {
    if (!script || !script.src) return '';
    try {
      var url = new URL(script.src, window.location.href);
      url.pathname = url.pathname.replace(/vsklo-utm-attribution\.js$/, 'vsklo-utm-attribution-core.js');
      url.search = '';
      return url.href;
    } catch (error) {
      return String(script.src || '').replace(/vsklo-utm-attribution\.js(?:\?.*)?$/, 'vsklo-utm-attribution-core.js');
    }
  }

  function isCartOrCheckout() {
    var path = String((window.location && window.location.pathname) || '').replace(/\/$/, '');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cartPath = (String(root).replace(/\/$/, '') + '/cart').replace(/\/$/, '');
    return path === '/cart' || path === cartPath || /\/cart$/.test(path) || /\/checkout/.test(path);
  }

  function hasTrackedLanding() {
    return TRACKED_QUERY.test(String((window.location && window.location.search) || ''));
  }

  function loadCore() {
    if (window.__VSKLO_UTM_ATTRIBUTION_V131__) return Promise.resolve(true);
    if (loadPromise) return loadPromise;

    var src = coreUrl();
    if (!src) return Promise.resolve(false);
    if (!window.VSKLOAssetLoader || typeof window.VSKLOAssetLoader.loadScript !== 'function') {
      return Promise.resolve(false);
    }

    loadPromise = window.VSKLOAssetLoader.loadScript({
      key: 'utm-attribution-core',
      src: src,
      parent: 'head',
      ready: function () {
        return window.__VSKLO_UTM_ATTRIBUTION_V131__ ? true : null;
      },
      label: 'UTM attribution core'
    })
      .then(function () { return true; })
      .catch(function () {
        loadPromise = null;
        return false;
      });

    return loadPromise;
  }

  // Public loader hook used by lead forms/callbacks so attribution is ready before CRM payload creation.
  window.VSKLO_UTM_ENSURE_CORE = loadCore;

  function scheduleDeferredLoad() {
    var run = function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(loadCore, { timeout: 5000 });
      } else {
        window.setTimeout(loadCore, 1800);
      }
    };

    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  if (hasTrackedLanding() || isCartOrCheckout()) {
    loadCore();
  } else {
    scheduleDeferredLoad();
  }
}());
